var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.batchCheckingWindow.visible
        ? _c("batch-checking-window", {
            ref: "batchCheckingWindow",
            attrs: {
              visible: _vm.batchCheckingWindow.visible,
              "allow-partial-check-pass":
                _vm.batchCheckingWindow.allowPartialCheckPass,
              lob: _vm.job.lob,
              jobs: _vm.batchCheckingWindow.jobs,
              "check-node": _vm.batchCheckingWindow.checkNode,
              "call-back": _vm.batchCheckingWindow.callBack,
              "call-back2": _vm.batchCheckingWindow.callBack2
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.batchCheckingWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.batchAuditDialog.visible
        ? _c("check-dialog", {
            ref: "batchAuditDialog",
            attrs: {
              "page-date": _vm.batchAuditDialog.adjustPageDate,
              "show-page-date": true,
              visible: _vm.batchAuditDialog.visible,
              "edit-approval-date": _vm.editApprovalDate,
              "is-editable": _vm.batchAuditDialog.isEditable,
              "po-no": _vm.batchAuditDialog.isEditable
                ? ""
                : _vm.batchAuditDialog.poNo
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.batchAuditDialog, "visible", $event)
              },
              confirm: _vm.batchAuditConfirmCB,
              returnDatePage: function(pageDate) {
                _vm.batchAuditDialog.adjustPageDate = pageDate
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }